import {TextareaItem} from "../../../model/items/textarea";
import TextHighlighterControls from "./TextHighlighterControls";
import TextContainer from "./TextContainer";
import m, {Vnode} from "mithril";
import TextSelection from "./TextSelection";
import {Mark} from "../TextHighlighter";


type JsonTextSelection = {position: number, content: string, comment: string|null};
export default class TextHighlighterComponent {
    public readonly controls: TextHighlighterControls;
    public readonly textContainer: TextContainer;

    constructor(
        private readonly text: string,
        private readonly textareaItemPositive: TextareaItem,
        private readonly textareaItemNegative: TextareaItem,
    ) {
        this.controls = new TextHighlighterControls(this.textareaItemPositive.form.questionary);
        this.textContainer = new TextContainer(
            text,
            this.textareaItemPositive.form.questionary,
            ()=>this.controls.marker,
            ()=>this.save());
    }


    public view(): Vnode {
        return m('.TextHighlighter', {}, [
            m(this.controls),
            m(this.textContainer),
        ])
    }



    public save(): void {
        const selections: {[mark: string]: JsonTextSelection[]} = {
            positive: [],
            negative: [],
        }

        let jsonSelection: JsonTextSelection|undefined;
        let textSelection: TextSelection|undefined;

        for(const token of this.textContainer.getTokens()) {

            if (!jsonSelection && token.selection) {
                jsonSelection = {
                    position: token.position,
                    comment: token.selection.comment,
                    content: token.content
                };
                textSelection = token.selection;
            } else if (jsonSelection && textSelection) {
                if (token.selection === textSelection) {
                    jsonSelection.content += token.content;
                } else {
                    selections[textSelection.mark].push(jsonSelection);
                    jsonSelection = undefined;
                    textSelection = undefined;
                }
            }
        }
        this.textareaItemPositive.set(selections.positive.length ? JSON.stringify(selections.positive) : '');
        this.textareaItemNegative.set(selections.negative.length ? JSON.stringify(selections.negative) : '');
    }


    public load(): void {

        let jsonSelections: {[mark: string]: JsonTextSelection[]} = {};

        try {
            jsonSelections.positive = this.textareaItemPositive.getVariable() ? JSON.parse(this.textareaItemPositive.getVariable()) : [];
            jsonSelections.negative = this.textareaItemNegative.getVariable() ? JSON.parse(this.textareaItemNegative.getVariable()) : [];
        } catch (e) {
            // JSON parse error
            console.warn("TextHighlighter: Unable to load answers - "+e.message);
        }

        const tokens = this.textContainer.getTokens();

        for (const mark of ['negative', 'positive']) {
            let pointer = 0;
            for (const selection of jsonSelections[mark]) {
                const textSelection = new TextSelection( <Mark>mark, selection.comment );
                const selectionEnd = selection.position + (selection.content?.length || 0);
                while (pointer < tokens.length) {
                    const token = tokens[pointer];
                    if (token.position >= selection.position && token.position < selectionEnd) {
                        token.selection = textSelection;
                    }
                    if (token.position >= selectionEnd) {
                        break;
                    }
                    pointer++;
                }
            }
        }
    }

    oninit() {
        this.load();
    }
}